import { CatHeading } from '@blocks-react/components/Heading';
import { CatModal } from '@blocks-react/components/Modal';

interface DealerLocatorTermsAndConditionModalProps {
  isOpen: boolean;
  onBlModalCancel: () => void;
  heading?: string;
  children: React.ReactNode;
  isDealerLocatorLoading?: boolean;
}

export const DealerLocatorTermsAndConditionModal = ({
  isOpen,
  onBlModalCancel,
  heading,
  children,
  isDealerLocatorLoading = false
}: DealerLocatorTermsAndConditionModalProps) => (
  <CatModal
    size="sm"
    isActive={isOpen}
    disableBackdropClick={isDealerLocatorLoading}
    onBlModalCancel={onBlModalCancel}
    dismissible={!isDealerLocatorLoading}
  >
    <CatHeading level="h5" slot="header">
      {heading}
    </CatHeading>
    {children}
  </CatModal>
);
